<script>
    import { oeLogo, mwLogo } from './footer-images'

    const date = new Date();

    const year = Math.max(2022, date.getFullYear());
</script>

<style>
    .footer {
        padding: 1em 0;
    }

    .footer-logos {
        margin: 1em 0 20px;
        flex-wrap: wrap;
        align-items: center;
    }

    .footer-logo {
        max-width: calc(100% - 22px);
        margin: 10px 0;
        flex-shrink: 0;
    }

    .footer-logo:first-child {
        margin-right: 10px;
    }

    .footer-logo:last-child {
        margin-left: 10px;
    }

    @media print {
        .footer {
            break-inside: avoid;
            page-break-inside: avoid;
            padding-bottom: 0;
        }

        .footer img {
            break-inside: avoid;
            page-break-inside: avoid;
        }

        .footer *:last-child {
            margin-bottom: 0;
        }
    }
</style>
<div class="footer">
    <div class="d-flex footer-logos">
        <img class="footer-logo" src={oeLogo()} alt="Our Environment"/>
        <div class="flex-1"></div>
        <img class="footer-logo" src={mwLogo()} alt="Manaaki Whenua - Landcare Research"/>
    </div>
    <p class="small">
        The data and information depicted in this factsheet has been derived from numerous sources. It may not be complete, correct or up to date. This factsheet is licensed by Landcare Research on an "as is" and "as available" basis and without any warranty of any kind, either express or implied. Landcare Research shall not be liable on any legal basis (including without limitation negligence) and expressly excludes all liability for loss or damage howsoever and whenever caused to a user of this factsheet.
    </p>
    <p class="small">
        © Landcare Research NZ Limited 2009-{year}. Creative Commons Attribution 3.0 NZ License.
    </p>
</div>
